var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.714 5.36683C12.9558 5.60859 12.9731 5.98982 12.7658 6.25149L12.714 6.30964L7.05719 11.9665C6.81544 12.2082 6.43421 12.2255 6.17253 12.0183L6.11438 11.9665L3.28596 9.13807C3.02561 8.87772 3.02561 8.45561 3.28596 8.19526C3.52771 7.95351 3.90894 7.93624 4.17062 8.14346L4.22876 8.19526L6.58611 10.552L11.7712 5.36683C12.013 5.12508 12.3942 5.10781 12.6559 5.31503L12.714 5.36683Z",
    fill: "#387E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.05b4850481b5c924aa6fc4be459c733a.svg";
export { ForwardRef as ReactComponent };